import React, { useEffect } from "react";
import Navbar from "../Navigation/Navigation";
import Footer from "../Footer/Footer";
import RelatedWorks from "./RelatedWorks";
import "./Mgrdetail.css";

export default function AiwoDetails() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="work-detail-page">
      <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', zIndex: 1000 }}>
        <Navbar />
      </div>

      <section className="project-info-section">
        <h1 className="project-title-heading">
          AIWO Health
        </h1>

        <p className="project-description">
          We partnered with AIWO Health to design a premium product packaging system for their wellness and longevity supplements. Our design approach focused on creating clean, sophisticated labels and box packaging that blend medical science with modern aesthetic appeal, conveying clinical excellence, brand credibility, and health optimization.
        </p>

        <div className="project-tags">
          <span className="info-tag">Packaging Design</span>
          <span className="info-tag">Brand Identity</span>
          <span className="info-tag">Print Collateral</span>
        </div>
      </section>

      {/* Full landscape image */}
      <div className="project-full-image-section">
        <img src="https://ascentbw.com/Images/Aiwo/Full1.webp" alt="AIWO Health Showcase" />
      </div>

      <div className="project-full-image-section">
        <img src="https://ascentbw.com/Images/Aiwo/Full2.webp" alt="AIWO Health Showcase" />
      </div>
      <section className="project-quote-section">
        <div className="quote-text right-aligned">
          "We designed a cohesive and premium packaging system for AIWO's supplement range, using high-quality materials and minimalist layouts to represent purity, health, and longevity."
        </div>
      </section>

      <section className="project-split-images-section">
        <img src="https://ascentbw.com/Images/Aiwo/Half1.webp" alt="Kelsun Lab Worker" />
        <img src="https://ascentbw.com/Images/Aiwo/Half2.webp" alt="Keel Labs Materials" />
      </section>

      <section className="project-quote-section">
        <div className="quote-text right-aligned">
          "Every bottle and box layout was engineered to communicate product efficacy and ingredients clearly, balancing strict medical clarity with premium consumer appeal."
        </div>
      </section>

      <div className="project-full-image-section">
        <img src="https://ascentbw.com/Images/Aiwo/Full3.webp" alt="AIWO Health Showcase" />
      </div>

      <section className="project-quote-section">
        <div className="quote-text right-aligned">
          "From sleek vitamin bottles to shipping boxes, we delivered a unified premium packaging system that stands out on retail shelves and creates a memorable unboxing experience."
        </div>
      </section>

      <RelatedWorks excludePath="/works/aiwo" />
      <Footer />
    </div>
  );
}
